import { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { Trophy, ArrowLeft } from 'lucide-react';

interface CourseCompletionProps {
    courseName: string;
    onBack: () => void;
}

export function CourseCompletion({ courseName, onBack }: CourseCompletionProps) {
    useEffect(() => {
        const duration = 3 * 1000;
        const animationEnd = Date.now() + duration;

        const interval = setInterval(() => {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                clearInterval(interval);
                return;
            }

            const particleCount = 50;

            confetti({
                particleCount,
                spread: 70,
                origin: { y: 0.6 },
                colors: ['#0EA5E9', '#38BDF8', '#7DD3FC'], // sky-600, sky-400, sky-300
            });

            confetti({
                particleCount,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: ['#0EA5E9', '#38BDF8', '#7DD3FC'],
            });

            confetti({
                particleCount,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: ['#0EA5E9', '#38BDF8', '#7DD3FC'],
            });
        }, 250);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-sky-50 to-slate-50 p-6">
            <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
                <div className="mb-8">
                    <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6">
                        <Trophy className="w-10 h-10 text-sky-600" />
                    </div>
                    <h1 className="text-3xl font-bold text-slate-900 mb-4">
                        Congratulations!
                    </h1>
                    <p className="text-xl text-slate-600">
                        You've successfully completed
                    </p>
                    <p className="text-2xl font-semibold text-sky-600 mt-2">
                        {courseName}
                    </p>
                </div>

                <div className="space-y-6">
                    <div className="bg-sky-50 rounded-lg p-6">
                        <h2 className="text-lg font-semibold text-slate-900 mb-2">
                            What's Next?
                        </h2>
                        <p className="text-slate-600">
                            Continue your learning journey by exploring more courses or share your achievement with your network.
                        </p>
                    </div>

                    <div className="flex flex-col space-y-4">
                        <button
                            onClick={onBack}
                            className="flex items-center justify-center px-6 py-3 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors"
                        >
                            <ArrowLeft className="w-5 h-5 mr-2" />
                            Back to Courses
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
} 